<template>

	<div class="mdc-select mdc-select--filled" ref="selectRef" :class="{'mdc-select--disabled': disabled, 'mdc-select--required':required}">
		<input type="hidden" :name="name" :id="theId" v-bind="$attrs" :disabled="disabled" :aria-label="label" :required="required" />
		<div class="mdc-select__anchor"
			role="button"
			aria-haspopup="listbox"
			aria-expanded="false"
			aria-labelledby="select-label selected-text"
			:aria-disabled="disabled"
			:aria-required="required"
			:tabindex="tabindex">
			<span class="mdc-select__ripple"></span>
			<span id="select-label" class="mdc-floating-label" v-html="label"></span>
			<span class="mdc-select__selected-text-container">
				<span id="selected-text" class="mdc-select__selected-text">{{ selected }}</span>
			</span>
			<span class="mdc-select__dropdown-icon">
			<svg
				class="mdc-select__dropdown-icon-graphic"
				viewBox="7 10 10 5" focusable="false">
				<polygon
					class="mdc-select__dropdown-icon-inactive"
					stroke="none"
					fill-rule="evenodd"
					points="7 10 12 15 17 10">
				</polygon>
				<polygon
					class="mdc-select__dropdown-icon-active"
					stroke="none"
					fill-rule="evenodd"
					points="7 15 12 10 17 15">
				</polygon>
			</svg>
			</span>
			<span class="mdc-line-ripple"></span>
		</div>

		<div class="mdc-select__menu mdc-menu mdc-menu-surface mdc-menu-surface--fullwidth">
			<ul class="mdc-deprecated-list" aria-label="Listbox" role="listbox" :class="{'mdc-deprecated-list--two-line': twoLine}">
				<li class="mdc-deprecated-list-item"
					role="option"
					:aria-selected="option.value === modelValue"
					:class="{'mdc-deprecated-list-item--selected': option.value === modelValue}"
					:data-value="option.value"
					:key="`${theId}_${key}`"
					v-for="(option, key) in options"
					@click="setOption(option)"
					>
					<span class="mdc-deprecated-list-item__text">
						<template v-if="twoLine">
							<span class="mdc-deprecated-list-item__primary-text" v-html="option.label"></span>
							<span class="mdc-deprecated-list-item__secondary-text" v-if="option.hint" v-html="option.hint"></span>
						</template>
						<template v-if="!twoLine">{{ option.label }}</template>
					</span>
				</li>
			</ul>
		</div>
	</div>

</template>

<script>
import { MDCSelect } from '@material/select'
import { v4 } from 'uuid'
import { toRaw } from 'vue'
import { isNull } from '../lib/utils'

export default {
	name: 'selectField',
	data: () => ({
		select: null,
	}),
	props: {
		options: {
			type: [Array],
			default: () => ([]),
		},
		id: {
			type: String,
			default: null,
		},
		modelValue: [String, Boolean, Object, Number],
		name: String,
		label: String,
		twoLine: Boolean,
		disabled: Boolean,
		tabindex: [Number, String],
		required: Boolean,
	},
	computed: {
		attrs() {
			return this.$attrs
		},
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
				this.$nextTick(() => {
					this.$emit('input', value)
					this.$emit('select', value)
				})
			}
		},
		selected() {
			const found = this.options.find((option) => toRaw(option.value) == toRaw(this.value))
			if (found) {
				return found.label
			}
			return ''
		},
		theId() {
			if (this.id) return this.id
			return v4()
		}
	},
	mounted() {
		this.select = new MDCSelect(this.$el)
		this.select.required = this.required
		this.select.listen('MDCSelect:change', () => {
			if (!this.options) return
			let _selected = this.options[this.select.selectedIndex]
			if (_selected != undefined && _selected != null) {
				this.value = _selected.value
			}
		})
	},
	emits: ['update:modelValue', 'input', 'select'],
	methods: {
		input(event) {
			if (event && !isNull(event.target)) {
				this.$emit('input', event.target.value)
			}
		},
		preselect() {
			if (!this.select || isNull(this.modelValue) || !this.options?.length) return

			const idx = this.options.findIndex(o => o.value == toRaw(this.modelValue))
			const option = this.options.find(o => o.value == toRaw(this.modelValue))

			if (idx > -1) {
				this.select.foundation.adapter.setSelectedIndex(idx)
			}

			if (option) {
				this.select.foundation.adapter.setSelectedText(option.label)
				this.$el.querySelector('#selected-text').innerHTML = option.label
				this.$el.querySelector('#select-label').classList.add('mdc-floating-label--float-above')
			}
		},
		setOption(option) {
			if (!option) return
			this.$emit('update:modelValue', option.value)
		},
	},
	watch: {
		select: {
			immediate: true,
			handler(val) {
				return this.preselect()
			}
		},
		options: {
			immediate: true,
			handler (newVal, oldVal) {
				if (this.select && newVal != oldVal) {
					this.$nextTick(() => {
						this.select.layoutOptions()
						this.$nextTick(() => {
							this.preselect()
						})
					})
				} else {
					this.$nextTick(() => {
						return this.preselect()
					})
				}
			},
		},
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				if (this.select && newVal != oldVal) {
					this.$nextTick(() => {
						// this.select.layoutOptions()
					})
					return this.preselect()
				}
			}
		},
		disabled: {
			immediate: true,
			handler (newVal) {
				if (this.select) {
					this.$nextTick(() => {
						this.select.disabled = newVal
					})
				}
			}
		}
	},
}
</script>

<style lang="scss" scoped>
@use "@material/list";
@use "@material/menu-surface/mdc-menu-surface";
@use "@material/menu/mdc-menu";
@use "@material/select/mdc-select";
@include list.deprecated-core-styles;

.mdc-select {
	$select: &;
	// z-index: 2;

	&__menu {
		z-index: 90;
		max-height: 10rem;
		width: 100%;
	}

	&:not(#{$select}--disabled) {

		&#{$select}--focused {
			.mdc-floating-label {
				color: var(--color--primary);
			}
		}
	}

	&--activated {
		#{$select}__anchor {
			border-color: var(--color--primary);
		}
	}

	&__anchor {
		min-width: 100px;
		width: auto;

		#{$select}__ripple {
			&:before {
				background-color: transparent;
			}
		}
	}

	&:not(.mdc-select-disabled) {
		&#{$select}--basic {
			#{$select}__anchor {
				background-color: transparent !important;
				border-width: 0;

				&:hover {
					background-color: transparent !important;
				}
			}
		}
	}


	.mdc-line-ripple {
		display: none;
	}

	.mdc-deprecated-list-item {
		&:hover,
		&:focus {
			background-color: rgba(220,220,220,0.5);
		}

		&.mdc-list-item--selected {
			background-color: var(--color--primary);
			color: var(--color--primary-text);
		}
	}
}
</style>
